"use client";
import ReactHtmlParser from "react-html-parser";

import { InternalButton } from "@sharedComponents/buttons";

import { useWindowStorage } from "@hooks/use-window-storage";

import { getBannerStorageKey } from "@constants/banner";

import styles from "./main.module.scss";

const defaultObj = {};

const CollapsibleBanner = ({ data = {}, store }) => {
  const { jsonContent, id } = data ?? defaultObj;
  const { rte_content = "", background_color } =
    (jsonContent && JSON.parse(jsonContent)) ?? defaultObj;

  const [showBanner, setShowBanner] = useWindowStorage(
    getBannerStorageKey(store.number, id),
    true,
    "sessionStorage",
  );

  if (!showBanner) {
    return;
  }

  return (
    <div className={styles.bannerContainer}>
      <div className={styles.bannerWrapper}>
        <div className={styles.banner} style={{ backgroundColor: background_color ?? "#cee4fe" }}>
          {rte_content && ReactHtmlParser(rte_content)}
          <InternalButton
            styleType="link"
            onClick={() => setShowBanner(false)}
            aria-label="Close"
          />
        </div>
      </div>
    </div>
  );
};

export default CollapsibleBanner;
